// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"305":"3bf98975","366":"1a89e686","712":"1f9d8c19","862":"72ee145e","989":"33834df0"}[chunkId] + ".chunk.css";
};